import { Divider } from '@mui/material';

const VerticalDivider = ({ style }: { style?: object }) => (
  <Divider orientation="vertical" flexItem style={style} />
);

export default VerticalDivider;
